export const status = {
    OPEN: 'OPEN'
}